import React, { useState } from "react";
import { Upload, Button, Typography, App, Space } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";
import HeaderLayout from "../../components/Header";
import FooterLayout from "../../components/Footer";
import PageHeader from "../../components/PageHeader";
import { fetchFileName } from "../helpers";

const { Title, Paragraph } = Typography;

const Word2Pdf = () => {
  const { notification, message } = App.useApp();
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState("");
  const isModule = window.location.pathname.includes("/dashboard/");

  const props = {
    name: "file",
    multiple: false,
    accept: ".doc,.docx",
    beforeUpload: (file) => {
      setFileList([file]);
      return false;
    },
    onRemove: () => {
      setFileList([]);
    },
    fileList,
  };

  const handleConvert = async () => {
    if (fileList.length === 0) {
      message.error("Please select a DOC or DOCX file.");
      return;
    }

    const formData = new FormData();
    formData.append("file", fileList[0]);
    formData.append("Source", isModule ? "Private-Web" : "Public-Web");

    try {
      setUploading(true);
      var response = { data: {} };
      if (isModule) {
        const authToken = isModule ? localStorage.getItem("token") : "";
        response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/api/Pdf/office-to-pdf`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
      } else {
        response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/api/WebsitePdf/website-office-to-pdf`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
      }

      if (!response.data.error && response.data.data) {
        setDownloadUrl(response.data.data["s3Url"] || "");
        message.success(response.data.message || "Success");
      } else {
        message.error(response.data.message || "Unknown Error");
      }
    } catch (error) {
      console.error(error);
      message.error("Conversion failed.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <>
      {isModule ? <PageHeader /> : <HeaderLayout />}
      <div className="converter-container">
        <Typography className="text-center">
          <Title level={3}>
            Convert <b>WORD</b> document to <b>PDF</b>.
          </Title>
          <Paragraph>
            Make your DOC and DOCX files more accessible by converting them to
            PDF.
          </Paragraph>
        </Typography>

        <div className="upload-box word-box">
          <Upload.Dragger {...props}>
            <Button icon={<UploadOutlined />} className="choose-files-button">
              CHOOSE FILES
            </Button>
            <p style={{ marginTop: 12 }}>or drop Files here</p>
          </Upload.Dragger>
        </div>

        <Space>
          <Button
            type="primary"
            className="convert-btn"
            onClick={handleConvert}
            loading={uploading}
          >
            Convert to PDF
          </Button>
          {!!downloadUrl && (
            <Button
              download={fetchFileName(downloadUrl)}
              href={downloadUrl}
              target="_blank"
              type="primary"
              className="convert-btn"
            >
              Download PDF
            </Button>
          )}
        </Space>
      </div>
      {!isModule && <FooterLayout />}
    </>
  );
};

export default Word2Pdf;
